import * as React from 'react';
import { PaymentInstructionLayout } from '../../../component/PaymentInstructionLayout.js';

const KlarnaAccount = ()=>{
    return /*#__PURE__*/ React.createElement(PaymentInstructionLayout, {
        info: "checkout.payment.method.klarna_account.info"
    });
};

export { KlarnaAccount };
//# sourceMappingURL=KlarnaAccount.js.map
